import { GameContextType } from "./types";
import { controlRoomCoordsList } from "../../coords/controlRoomCoordsList";

export const initialContext: GameContextType = {
    boardPieces: [],
    selectedLesson: undefined,
    visibleMapCoordsList: [...controlRoomCoordsList],
};
